/**
 * Styled Components - Created by jorge on 03/08/18.
 */
import styled from 'styled-components'
import {
  WHITE,
  GRAY_DARK,
  BLACK_BG,
  BLUE,
  WHITE_BG,
  RED,
  BLACK,
  BLUE_DARK
} from '../../theme/colors'
import Input from 'antd/lib/input'
import Select from 'antd/lib/select'
import BackTop from 'antd/lib/back-top'
import Icon from 'antd/lib/icon'
import { AVENIR_NEXT } from '../../theme/fonts'
import { PrimaryCTA } from '../../theme/components'

interface DivProps {
  isTeamStore?: boolean
  selected?: boolean
  disabled?: boolean
  secondary?: boolean
  marginLeft?: string
}

type SelectType = {
  selectWidth?: string
  enabled?: boolean
  highlightFields?: boolean
}

export const Container = styled.div`
  background-color: ${WHITE};
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  margin-top: 88px;
  padding-inline: var(--spacing-72);
  @media (max-width: 1024px) {
    padding-inline: 0;
  }
  @media (max-width: 767px) {
    margin-top: 0;
    user-select: none !important;
  }
`

export const Content = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  max-width: 1658px;
  margin: 0 auto;
  margin-top: var(--spacing-16);
  margin-bottom: var(--spacing-64);
  width: 100%;

  @media (min-width: 320px) and (max-width: 767px) {
    display: block;
    margin-top: 0;
  }
`

export const ImagePreview = styled.div`
  width: 60%;
  position: relative;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    padding: 0;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    width: 100%;
  }

  @media (min-width: 769px) {
    align-self: start;
    grid-column: 1 / span 1;
    grid-row: 1 / span 1;
    justify-self: stretch;
    max-width: none;
    position: sticky;
    top: 108px;
    width: 100%;
  }
`
export const ProductData = styled.div`
  margin-left: var(--spacing-64);
  max-width: 440px;
  width: 100%;
  .fields {
    display: flex;
    flex-direction: column;
    margin-bottom: var(--spacing-24);
  }
  .fields-secondary {
    flex-flow: row;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: var(--spacing-24);
    border-bottom: 1px solid var(--neutral-border-med);
  }
  #notEditable {
    display: flex;
    padding: var(--spacing-16);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-14);
    color: var(--neutral-darkest);
    font: 600 12px/20px var(--font-inter);
    background: var(--neutral-lightest-block);
    margin-bottom: 24px;
    .anticon {
      font-size: 22px;
      color: var(--accent-red);
    }
  }
  @media (max-width: 767px) {
    max-width: 100%;
    margin-left: 0;
    margin-top: var(--spacing-16);
    padding-inline: var(--spacing-16);
    .fields-secondary {
      padding-bottom: 0;
      border-bottom: 0;
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const ProductDescription = styled.div`
  padding: 12px;
  padding-top: 4px;
  padding-bottom: 0px;
`

export const DescriptionSection = styled.div`
  background: #fdfdfd;
  justify-content: center;
  display: flex;
`

export const DescriptionWidth = styled.div`
  max-width: 1128px;
`

export const BackTopStyled = styled(BackTop)`
  &.ant-back-top {
    left: 30px !important;
    right: unset !important;
    bottom: 124px !important;
  }
`

export const BackButton = styled.div`
  font-size: 15px;
  display: flex;
  align-items: center;
  background: #ffffffcf;
  border-radius: 90px;
  padding: 10px;
  min-width: 83px;
  font-weight: bold;
  font-family: Avenir;
  box-shadow: 0px 1px 4px -1px grey;
`

export const BackIcon = styled(Icon)`
  font-size: 30px;
  margin-right: 8px;
`

export const RenderContainer = styled.div`
  aspect-ratio: 1 / 1;
  background: var(--lightened-cool);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-width: 792px;
  overflow: hidden;
  padding: var(--spacing-16);
  position: relative;
  text-align: center;
  width: 100%;

  div:has(> #render-3d) {
    height: 100%;
    width: 100%;
  }

  #render-3d {
    height: 100% !important;
  }

  @media (max-width: 768px) {
    aspect-ratio: 3 / 4;
    &[data-is2d="true"] {
      aspect-ratio: unset; 
    }
    padding: var(--spacing-8);

    div:has(> #render-3d) {
      height: auto;
      inset: var(--spacing-8);
      position: absolute;
      width: auto;
    }
  }
`
export const BannerMaterialSection = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  margin-top: 8px;
`

export const SizeChart = styled.img`
  max-width: 128px;
  width: 100%;
  object-fit: contain;
  margin: 0 0 30px 0;
  &:hover {
    cursor: pointer;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    max-width: 100%;
    object-fit: contain;
    margin: 0 0 22px 0;
    padding-right: 22px;
    height: 54px;
    width: 100%;
  }
`

export const BannerMaterial = styled.img`
  max-width: 85px;
  object-fit: cover;
  max-height: 85px;
  margin-right: 8px;
  border-radius: 3px;
  @media (max-width: 698px) {
    max-width: 82px;
  }
`

export const HowItFits = styled.div`
  display: none;
  align-items: center;
  background: var(--neutral-white);
  border: var(--border-regular) solid var(--neutral-muted);
  bottom: var(--spacing-16);
  box-sizing: border-box;
  color: var(--neutral-body);
  font: 600 12px / 20px var(--font-barlow);
  gap: 8px;
  height: 42px;
  justify-content: center;
  left: calc(50% - 68px);
  letter-spacing: 1px;
  margin: 0;
  padding: var(--spacing-8) var(--spacing-16);
  position: absolute;
  text-transform: uppercase;
  white-space: nowrap;
  width: auto;
  z-index: 2;

  @media (max-width: 768px) {
    bottom: var(--spacing-8);
    font: 600 12px / 18px var(--font-barlow);
  }
`

export const SeparatedRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  @media (max-width: 884px) {
    flex-wrap: wrap;
  }
`

export const Title = styled.div`
  overflow: hidden;
  color: var(--neutral-darkest);
  text-overflow: ellipsis;
  white-space: nowrap;
  font: 700 40px/42px var(--font-barlow-semi-condensed);
  text-transform: capitalize;
  @media (max-width: 767px) {
    font: 700 32px/42px var(--font-barlow-semi-condensed);
  }
`

export const Subtitle = styled.div`
  color: var(--neutral-secondary);
  font: 400 14px/22px var(--font-inter);
  margin-top: var(--spacing-8);
  text-transform: uppercase;
  span {
    text-transform: capitalize;
  }
  @media (max-width: 767px) {
    line-height: 20px;
  }
`

export const EditDesignButton = styled(PrimaryCTA)`

`

export const SerieBadge = styled.div`
  margin-bottom: var(--spacing-8);
  color: var(--neutral-secondary);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  &[data-serie="0"] {
    color: var(--series-xpo);
  }
  &[data-serie="1"] {
    color: var(--series-pro);
  }
  &[data-serie="2"] {
    color: var(--series-club);
  }
  @media (max-width: 767px) {
    margin-top: var(--spacing-16);
  }
`

export const SubtitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: var(--spacing-24);
  color: var(--neutral-muted);
  font: 400 14px/22px var(--font-inter);
  padding-bottom: var(--spacing-12);
  border-bottom: 1.25px solid var(--neutral-border-light);
  .ratingsContainer {
    margin: 0;
  }

  [data-appearance='prod-v2-desktop'] > div#reviewsCount {
    color: var(--neutral-body);
    font: 400 14px / 20px var(--font-inter);
    margin-left: var(--spacing-8);
    height: fit-content;
    width: auto;
    text-decoration: underline;
    cursor: pointer;
  }
  @media (max-width: 767px) {
    [data-appearance='prod-v2-desktop'] > div#reviewsCount {
      text-decoration: unset;
    }
  }
`

export const PricesRow = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  border: ${({ isTeamStore }: DivProps) => !isTeamStore ? '1px solid var(--neutral-border-light)' : 'unset'};
  padding: ${({ isTeamStore }: DivProps) => !isTeamStore ? 'var(--spacing-16)' : '0'};
  overflow: hidden;
  [data-appearance='prod-v2'] {
    display: flex;
    flex-flow: column;
    align-items: center;
    text-align: center;
    color: var(--neutral-secondary);
    font-family: var(--font-barlow);
    #bottomLabels {
      display: flex;
      flex-direction: column;
      justify-content: center;
      #marginLabel {
        margin-top: var(--spacing-4);
        background: unset !important;
        color: var(--neutral-muted);
        text-align: center;
        font: 500 11px/16px var(--font-barlow);
        letter-spacing: 0.158px;
      }
    }
    #quantityLabel {
      font: 500 11px/14px var(--font-barlow);
      margin-top: var(--spacing-4);
    }
    #priceLabel {
      color: var(--neutral-darkest);
      font: 600 20px/26px var(--font-barlow);
    }
  }
  #priceLbl {
    margin-left: var(--spacing-8);
    color: var(--neutral-secondary);
    font: 400 14px/22px var(--font-inter);
    b {
      color: var(--neutral-darkest);
      font-weight: 600;
    }
  }
  #vat {
    font-weight: normal;
    font-size: 12px;
    color: #979797;
    position: absolute;
    margin-top: -14px;
  }
  @media (max-width: 767px) {
    #vat {
      bottom: ${({ isTeamStore }: DivProps) => isTeamStore ? '-2px' : 'unset'};
    }
    [data-appearance='prod-v2'] #priceLabel {
      font: 600 16px/22px var(--font-barlow);
    }
    [data-appearance='prod-v2'] #quantityLabel {
      font: 500 10px/14px var(--font-barlow);
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    justify-content: space-between;
  }
  ${({ secondary }: DivProps) => secondary ? `
    & > div {
      display: none;
      :first-child {
        display: block;
      }
    }
  ` : ''}
`

export const PriceOnlyDesktop = styled.div`
display: none;
@media (min-width: 768px) {
  display: flex;
  position: relative;
  width: 100%;
  max-width: 100%;
  margin-top: var(--spacing-12);
  overflow-x: auto;
  ${({ isTeamStore }: DivProps) => isTeamStore ? `
    margin-top: 4px;
    flex-flow: column;
    line-height: 1.15;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-border-light);
  ` : ''};
  > * {
    flex: 0 0 auto;
  }
  [data-appearance='prod-v2'] {
    > * {
      padding-inline: 10px;
    }
  }
  > *:not(:last-child) [data-appearance='prod-v2'] {
    border-right: 1px solid var(--neutral-border-light);
  }
}
`

export const PriceOnlyMobile = styled.div`
display: none;
@media (min-width: 320px) and (max-width: 480px) {
  display: flex;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-mask-image: none;
  mask-image: none;
  ${({ isTeamStore }: DivProps) => isTeamStore ? `
    margin-top: 4px;
    flex-flow: column;
    line-height: 1.15;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-border-light);
  ` : ''};

  /* 2. Attach the CSS Scroll-Driven Animation */
  /* This ties the animation's progress directly to the horizontal scrollbar */
  animation: overflow-mask linear both;
  animation-timeline: scroll(inline self);
  @keyframes overflow-mask {
    /* From 0% (start) to 99% scrolled: Show the 80px fade out */
    0%, 99% {
      -webkit-mask-image: linear-gradient(to right, black calc(100% - 80px), transparent 100%);
      mask-image: linear-gradient(to right, black calc(100% - 80px), transparent 100%);
    }

    /* At exactly 100% scrolled: Make the mask solid so the last item is fully visible */
    100% {
      -webkit-mask-image: linear-gradient(to right, black 100%, transparent 100%);
      mask-image: linear-gradient(to right, black 100%, transparent 100%);
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
  [data-appearance='prod-v2'] {
    > * {
      padding-inline: var(--spacing-8);
    }
  }
  > *:not(:last-child) [data-appearance='prod-v2'] {
    border-right: 1px solid var(--neutral-border-light);
  }
  > * {
    flex: 0 0 auto;
  }
}
`

export const AvailablePrices = styled.div`
  display: flex;
  flex-flow: column;
  align-self: stretch;
  align-items: center;
  flex: 1;
  white-space: nowrap;
  &:first-child > div > div:first-child {
    font-weight: normal;
  }
`
export const DescriptionTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 14px;
  text-align: center;
  background: #EFF2F4;
  padding: 6px;
`

export const Description = styled.div`
  color: #5f6062;
  font-size: 16px;
  line-height: 23px;
`

export const DescriptionRich = styled.div`
  width: 100%;
  margin-top: -10px;
  font-family: Avenir;
  line-height: 1.43;
`

export const BuyNowOptions = styled.div`
  margin-top: var(--spacing-24);
  position: relative;
  margin-bottom: ${({ secondary }: DivProps) => secondary ? '0' : '22px'};
`

export const SectionRow = styled.div`
  margin-bottom: var(--spacing-24);
`

export const SectionTitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: var(--spacing-8);
`

export const SectionTitle = styled.div`
  color: #0A0A09;
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
`

export const SectionButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  &.grid {
    gap: var(--spacing-6);
    justify-content: flex-start;
  }
  .buttonWrapper {
    flex: 1;
  }
  .sizeBtn {
    width: 83px;
    flex: unset;
    @media (max-width: 768px) {
      width: auto;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    &.grid {
      display: grid;
      grid-template-columns: repeat(auto-fit,minmax(18%,1fr));
    }
  }

  @media (min-width: 769px) and (max-width: 1023px) {
    flex-wrap: wrap;
  }
`

interface ButtonProps {
  selected: boolean
  highlight?: boolean
}

export const SectionButton = styled.div`
  align-items: center;
  background-color: ${({ selected }: ButtonProps) => selected ? BLACK_BG : WHITE};
  color: ${({ selected }: ButtonProps) => selected ? WHITE : 'var(--neutral-darkest)'};
  border: ${({ selected }: ButtonProps) =>
    selected ? `0.5px solid ${BLACK_BG}` : '0.5px solid #d3d3d3'};
  display: flex;
  padding: var(--spacing-8) var(--spacing-16);
  justify-content: center;
  height: var(--spacing-38);
  width: 100%;
  transition: all .25s;
  font: 600 12px/14px var(--font-barlow);
  letter-spacing: 1px;
  &:hover {
    cursor: pointer;
    border-color: var(--neutral-darkest);
  }

  ${({ highlight }: ButtonProps) => highlight ? `
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        background-color: #fff3f3 !important;
      }

      70% {
        filter: drop-shadow(0 0 15px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        background-color: #white !important;
      }

      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        background-color: #fff3f3 !important;
      }
    }
    background-color: #fff3f3 !important;
  ` : ''}
`
export const SizeRowTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ButtonsRow = styled.div`
  display: flex;
  height: 42px;
  margin-left: 12px;
  flex: 1;
  & > div {
    width: 100%;
  }
  .anticon-shopping-cart {
    font-size: 16px;
    margin-bottom: 3px;
    vertical-align: middle;
    margin-right: 12px;
  }
  .ant-btn {
    color: ${({ disabled }: DivProps) => disabled ? 'var(--neutral-muted)' : WHITE} !important;
    border: ${({ disabled }: DivProps) => disabled ? 'var(--neutral-border-light)' : BLACK_BG} !important;
    background-color: ${({ disabled }: DivProps) => disabled ? 'var(--neutral-border-light)' : BLACK_BG} !important;
    font: 600 12px/18px var(--font-barlow);
    letter-spacing: 1px;
    text-transform: uppercase;
    width: 100%;
    &:hover {
      cursor: ${({ disabled }: DivProps) => disabled ? 'not-allowed' : 'pointer'};
    }
  }
  @media (max-width: 698px) {
    .ant-btn {
      width: 100%;
    }
  }
  &:hover {
    cursor: ${({ disabled }: DivProps) => disabled ? 'not-allowed' : 'pointer'};
  }
  ${({ secondary }: DivProps) => secondary ? `
    flex-wrap: wrap;
  ` : ''}
`

export const CartLabel = styled.div``

export const CartIcon = styled(Icon)`
  margin-right: 10px;
`

export const DetailsList = styled.ul`
  padding: 10px 0px 0px 20px;
`

export const DetailsListItem = styled.li`
  margin-bottom: 15px;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex: 1;
  height: 60vh;
  justify-content: center;
  align-items: center;
`

export const PrivateContainer = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  height: 80vh;
  justify-content: center;
`
export const PrivateTitle = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  height: 22px;
  letter-spacing: 0.11px;
  line-height: 22px;
  margin-bottom: 10px;
  margin-top: -25px;
  text-align: center;
  width: 100%;
`
export const PrivateSubtitle = styled.div`
  color: #5f6062;
  font-size: 16px;
  height: 23px;
  letter-spacing: 0.11px;
  line-height: 23px;
  text-align: center;
  width: 100%;
`

export const layoutStyle = {
  backgroundColor: WHITE_BG,
}

export const InfoTag = styled.div`
  display: flex;
  padding: var(--spacing-4) var(--spacing-8);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-6);
  background: #E9FFED;
  color: var(--accent-green);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  span {
    font-size: 24px;
    margin-top: -2px;
  }
`

export const ThreeDButton = styled.img`
  padding: 8px;
  background: black;
  filter: ${({ selected }: DivProps) => selected ? 'invert(0)' : 'invert(1)'};
  z-index: 2;
  position: absolute;
  bottom: var(--spacing-8);
  height: var(--spacing-42);
  object-fit: contain;
  right: var(--spacing-8);
  width: var(--spacing-42);
  transition: all .5s;
  -webkit-touch-callout: none !important;
  user-select: none !important;
`

export const InfoMessage = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: -28px;
  background: #272727;
  vertical-align: middle;
`

export const FingerIcon = styled.img`
  max-width: 24px;
  vertical-align: middle;
  z-index: 2;
  background: #272727;
  margin-right: 8px;
`

export const UpgradesSection = styled.div`
  margin-bottom: var(--spacing-24);
`

export const UpgradesDiv = styled.div`
  display: flex;
  flex-flow: column;
`

export const UpgradeInput = styled.div`
  width: 100%;
  margin-top: 12px;
`

export const UpgradeTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-8);
  color: var(--neutral-darkest);
  font: 400 12px/20px var(--font-inter);
`

export const StyledSelect = styled(Select)`
  width: 100%;
  .ant-select-selection {
    height: 42px;
    border-radius: 0;
    border-color: ${({ highlightFields }: SelectType) => highlightFields ? RED : '#D4D4CF'};
    transition: all .25s;
    ${({ enabled }: SelectType) => enabled ? `
      background: var(--accent-trans-lime);
      border: 1px solid var(--accent-green);
      border-left-width: 4px;
    ` : ''}
    &:focus {
      box-shadow: unset;
    }
  }
  .ant-select-selection__rendered {
    color: #0A0A09;
    font: 400 14px/40px var(--font-inter);
  }
  .anticon {
    color: var(--neutral-darkest);
  }
  .ant-select-selection-selected-value {
    width: 100%;
  }
  transition: all .25s;
  ${({ highlightFields }: SelectType) => highlightFields ? `
    .ant-select-selection {
      background: #fff3f3;
    }
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }

      70% {
        filter: drop-shadow(0 0 20px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        .ant-select-selection {
          background: #white !important;
        }
      }

      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }
    }
  ` : ''}
`

export const UpgradeOption = styled.span`
  color: #0A0A09;
  font: 400 14px/20px var(--font-inter);
  display: inline-flex;
  justify-content: space-between;
  padding-inline: 6px;
  width: 100%;
  .badge {
    color: var(--accent-green);
    font: 600 12px/20px var(--font-barlow);
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .ant-select-dropdown-menu-item-selected & .badge {
    display: none;
  }
`

export const QuestionSpan = styled.span`
  margin-left: var(--spacing-8);
  border-radius: 8px;
  background: #EDEDEB;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  color: #4A4A48;
  font: 700 10px/16px var(--font-barlow);

  &::after {
    content: '?';
  }
  &:hover {
    cursor: pointer;
  }
`

export const maskBlurred = {
  backdropFilter: 'blur(3px)'
}

export const buttonStyleModern = {
  background: WHITE,
  color: 'black',
  border: '1px solid black',
  fontWeight: 600,
  width: '28px',
  padding: 0,
  borderRadius: '25px',
  height: '28px',
}

export const InfoBodyModern = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`

export const InfoImage = styled.img`
  max-width: 75vw;
  border-radius: 5px;
  width: 100%;
  @media (max-width: 768px) {
    max-width: 886px;
    margin-top: 0px;
  }
`

export const InfoURL = styled.a`
  color: ${BLUE};
`

export const QuantitySection = styled.div`
  display: flex;
  align-items: center;
`

export const DiscontinuedMessage = styled.div`
  margin-top: 28px;
  margin-left: 16px;
  color: ${RED};
  margin-right: 16px;
  padding: 32px;
  text-align: center;
  border: 1px solid ${RED};
  border-radius: 4px;
`

export const QtyBtn = styled.div`
  width: 38px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.25px solid var(--neutral-border-med);
  color: var(--neutral-darkest);
  font: 600 16px/22px var(--font-barlow);
  letter-spacing: -0.1px;
  transition: background-color .15s, border-color .25s;
  &:hover {
    cursor: pointer;
    border-color: var(--neutral-darkest);
  }
  &:active {
    background-color: var(--neutral-darkest);
    color: var(--neutral-white);
  }
`

export const QuantityInput = styled.input`
  width: 42px;
  height: 42px;
  border: unset;
  border-top: 1.25px solid var(--neutral-border-med);
  border-bottom: 1.25px solid var(--neutral-border-med);
  color: var(--neutral-darkest);
  text-align: center;
  display: flex;
  align-items: center;
  font: 600 16px/22px var(--font-barlow);
  letter-spacing: -0.1px;
  /* Disable browser default arrow styles */
  appearance: textfield;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const VariablesSection = styled.div`
  margin-bottom: var(--spacing-24);
  .varSelector {
    display: flex;
    width: 100%;
    margin-top: var(--spacing-8);
    justify-content: space-between;
  }
  .capsMessage {
    margin-top: var(--spacing-8);
    color: var(--neutral-muted);
    font: 400 14px/22px var(--font-inter);
  }
  .link {
    text-decoration: underline;
    margin-left: 4px;
    cursor: pointer;
  }
  @media (max-width: 767px) {
    .capsMessage {
      font-size: 11px;
    }
  }
`

export const CartBtnDiv = styled.div`
  display: flex;
`

export const VariablesInputs = styled.div`
  display: flex;
  flex-flow: column;
`

export const InputVariable = styled(Input)`
  height: 47px;
  padding: var(--spacing-4) var(--spacing-16);
  border: var(--border-regular) solid var(--neutral-border-med);
  background: var(--neutral-white);
  border-radius: 0;
  margin-top: var(--spacing-8);
  color: var(--neutral-body);
  font: 400 14px/22px var(--font-inter);
`

export const AnimatedDiv = styled.div`
  position: fixed;
  bottom: 24px;
  left: 30px;
  z-index: 3;
`

export const BounceDiv = styled.div`
  ${({ secondary }: DivProps) => secondary ? `
  animation: wobble-hor-bottom 0.8s 0s 2 both;
  @keyframes wobble-hor-bottom {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-15px);
    }
    60% {
      transform: translateY(-7px);
      filter: grayscale(0.7);
    }
  }
  ` : ''}
`

export const CartIconBounce = styled.div`
  background: ${WHITE};
  border-radius: 50%;
  width: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 68px;
  box-shadow: 0px 1px 9px -2px #6e6e6e;
  transition: all .25s;
  .ant-badge-count {
    transform: translateX(30%);
  }
  animation: fade-in-leftDesuZ 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) 1s both;
  @keyframes fade-in-leftDesuZ {
    0% {
      transform: translateX(-30px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  &:hover {
    cursor: pointer;
    filter: opacity(0.7);
  }
`

export const ShoppingCartIcon = styled(Icon)`
  font-size: 32px;
  color: ${BLACK};
`

export const ModalTitleDisabled = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const IconPrint = styled(Icon)`
  margin-right: 12px;
`

export const InfoBodyPrint = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const MSRPDiv = styled.div`
  display: flex;
  margin-bottom: var(--spacing-8);
  color: var(--neutral-secondary);
  font: 600 14px / 22px var(--font-inter);
`

export const StoreClosed = styled.div`
  display: flex;
  padding: var(--spacing-24);
  align-items: flex-start;
  gap: var(--spacing-16);
  align-self: stretch;
  background: var(--neutral-darkest);
  color: var(--neutral-white);
  font: 600 16px / 22px var(--font-barlow);
  letter-spacing: -0.1px;
  margin-top: var(--spacing-24);
  .anticon {
    color: var(--accent-red);
    font-size: 18px;
  }
  #contactStore {
    color: var(--neutral-muted);
    font: 400 14px / 22px var(--font-inter);
    margin-top: 8px;
    cursor: pointer;
  }
`

export const Variants = styled.div`
  display: flex;
  gap: var(--spacing-8);
  position: absolute;
  right: var(--spacing-16);
  top: var(--spacing-16);
  z-index: 4;

  @media (max-width: 768px) {
    bottom: 58px;
    flex-direction: column;
    right: var(--spacing-8);
    top: unset;
  }
`

export const VariantButton = styled.img`
  background: var(--neutral-white);
  border: var(--border-regular) solid ${({ selected }: DivProps) =>
    selected ? 'var(--neutral-darkest)' : 'var(--neutral-border-light)'};
  cursor: pointer;
  height: 64px;
  width: 64px;
  padding: 10px;
  object-fit: contain;
  filter: ${({ selected }: DivProps) => selected ? 'invert(1)' : 'none'};
  transition: all .2s;
  &:hover {
    border-color: var(--neutral-darkest);
  }

  @media (max-width: 767px) {
    height: 42px;
    width: 42px;
    padding: 4px;
  }
`

export const ImportedIcon = styled(Icon)`
  font-size: 11px;
  transform: rotate(-90deg);
  background: white;
  color: #8d75bf;
  padding: 5px;
  border: 1px solid #beafdd;
  box-shadow: none;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  border-top-left-radius: 0;
  border-top-right-radius: 25px;
  margin-left: 12px;
  vertical-align: text-top;
`

export const StyledButtonWrapper = styled.div`
  .ant-btn-primary  {
    background-color: ${BLUE_DARK};
    border-color: ${BLUE_DARK};
  }
  .ant-btn-primary:hover {
    background-color: ${BLUE_DARK};
    border-color: ${BLUE_DARK};
  }
  @media (max-width: 698px) {
    margin: 18px 0 0;
    width: 100%;
  }
  margin-left: ${({ marginLeft }: DivProps) => marginLeft || '0px'};
`

export const CustomizeButton = styled.a`
  height: 50px;
  width: 256px;
  border: 1px solid ${BLUE};
  border-radius: 2px;
  cursor: pointer;
  font-weight: 600;
  background-color: ${WHITE};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  color: ${BLUE};
  font-size: 16px;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  &:hover {
    background: ${BLUE};
    color: ${WHITE};
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const ColorWheel = styled.img`
  width: 20px;
  margin-right: 12px;
`

export const DetailsDiv = styled.div`
  margin-top: 14px;
  margin-bottom: -15px;
`

export const DetailsTitle = styled.div`
  font-weight: bold;
  font-size: 15px;
  font-family: Avenir;
  margin-bottom: 6px;
`

export const TopLabel = styled.div`
  color: var(--neutral-secondary);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  margin-bottom: 4px;
  text-transform: uppercase;
`

export const PriceDiv = styled.div`
  color: var(--neutral-darkest);
  font: 600 24px/30px var(--font-barlow-semi-condensed);
  letter-spacing: 0.4px;
  .percent {
    display: inline;
    color: var(--accent-red);
    font: 600 14px/24px var(--font-barlow);
  }
  @media (max-width: 698px) {
    display: flex;
    align-items: flex-end;
    .percent {
      margin-left: 4px;
    }
  }
`

export const SubPriceDiv = styled.div`
  display: flex;
  color: var(--neutral-muted);
  font: 400 13px/17px var(--font-inter);
  margin-top: 4px;
  .bottomLabel {
    margin-left: 4px;
    text-decoration: line-through;
  }
`

export const AddItemToSizeRec = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;
  gap: var(--spacing-8);
  color: var(--accent-green);
  font: 600 14px/22px var(--font-inter);
  text-decoration-line: underline;
  text-underline-offset: 10%;
  text-underline-position: from-font;
  cursor: pointer;
`

export const AssistanceDiv = styled.div`
  position: ${({ secondary }: DivProps) => secondary ? 'unset' : 'absolute'};
  bottom: -4px;
  right: 8px;
  width: fit-content;
  padding: 8px 20px;
  text-align: center;
  font-size: 13px;
  background-color: #e6ffe5;
  border-radius: 5px;
  border: 1px solid #bfe5b8;
  @media (max-width: 1128px) {
    position: unset;
  }
  @media (max-width: 768px) {
    font-size: 10px;
    padding: 10px 18px;
  }
  @media (max-width: 740px) {
    justify-content: center;
    margin-top: 18px;
  }
  @media (max-width: 480px) {
    width: 100%;
  }
`

export const SectionLink = styled.a`
  color: ${BLUE};
  margin-top: 8px;
  display: block;
  &:hover {
    cursor: pointer;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/CustomProductDetail/styledComponents.tsx